import script from "./CreatePizzaModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatePizzaModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreatePizzaModal.vue?vue&type=style&index=0&id=05296e68&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05296e68"]])

export default __exports__